"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _class, _temp2;

var _reactBootstrap = require('react-bootstrap');

var _components2 = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    PasswordChangeView: {
        displayName: 'PasswordChangeView'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/components/PasswordChange/default/PasswordChangeView.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}
//import ReactAlert from 'react-s-alert';

var PasswordChangeView = _wrapComponent('PasswordChangeView')((_temp2 = _class = function (_Component) {
    (0, _inherits3.default)(PasswordChangeView, _Component);

    function PasswordChangeView() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, PasswordChangeView);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = PasswordChangeView.__proto__ || (0, _getPrototypeOf2.default)(PasswordChangeView)).call.apply(_ref, [this].concat(args))), _this), _this.onSubmit = function (event) {
            event.preventDefault();
            _this.props.onSubmit(event);
        }, _this.showError = function () {
            var _this$props = _this.props,
                error = _this$props.error,
                errorCode = _this$props.errorCode,
                lang = _this$props.lang;


            if (error) {
                if (errorCode === null || errorCode === undefined) {
                    return _react3.default.createElement(
                        _reactBootstrap.Alert,
                        { bsStyle: 'danger', className: 'inner-right-xs' },
                        lang['store.common.server_is_unavailable']
                    );
                } else {
                    return _react3.default.createElement(
                        _reactBootstrap.Alert,
                        { bsStyle: 'danger', className: 'inner-right-xs' },
                        lang[error]
                    );
                }
            }

            return '';
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(PasswordChangeView, [{
        key: 'render',
        value: function render() {
            var lang = this.props.lang;


            return _react3.default.createElement(
                _components2.Preloader,
                { preload: this.props.preload },
                this.showError(),
                _react3.default.createElement(
                    'section',
                    { className: 'registration_page', id: 'registration-form' },
                    _react3.default.createElement(
                        'div',
                        { className: 'bordered' },
                        _react3.default.createElement(
                            _reactBootstrap.Form,
                            { onSubmit: this.onSubmit },
                            _react3.default.createElement(
                                _reactBootstrap.FormGroup,
                                { controlId: 'password' },
                                _react3.default.createElement(
                                    _reactBootstrap.ControlLabel,
                                    null,
                                    lang['store.password_change.previous_password']
                                ),
                                _react3.default.createElement(_reactBootstrap.FormControl, {
                                    type: 'password',
                                    name: 'PASSWORD',
                                    value: this.props.oldPass,
                                    onChange: this.props.onChangeOldPass,
                                    placeholder: lang['store.password_change.enter_previous_password']
                                })
                            ),
                            _react3.default.createElement(
                                _reactBootstrap.FormGroup,
                                { controlId: 'passwordNew' },
                                _react3.default.createElement(
                                    _reactBootstrap.ControlLabel,
                                    null,
                                    lang['store.password_change.enter_new_password']
                                ),
                                _react3.default.createElement(_reactBootstrap.FormControl, {
                                    type: 'password',
                                    name: 'PASSWORD_NEW',
                                    value: this.props.newPass,
                                    onChange: this.props.onChangeNewPass,
                                    placeholder: lang['store.password_change.create_password']
                                })
                            ),
                            _react3.default.createElement(
                                _reactBootstrap.FormGroup,
                                { controlId: 'repasswordNew' },
                                _react3.default.createElement(
                                    _reactBootstrap.ControlLabel,
                                    null,
                                    lang['store.password_change.repeat_new_password']
                                ),
                                _react3.default.createElement(_reactBootstrap.FormControl, {
                                    type: 'password',
                                    name: 'REPASSWORD_NEW',
                                    value: this.props.newRePass,
                                    onChange: this.props.onChangeNewRePass,
                                    placeholder: lang['store.password_change.repeat_password']
                                })
                            ),
                            _react3.default.createElement(
                                _reactBootstrap.FormGroup,
                                null,
                                _react3.default.createElement(
                                    _reactBootstrap.Button,
                                    {
                                        type: 'submit',
                                        bsStyle: 'primary',
                                        className: 'form-control',
                                        disabled: this.props.disabledSubmit
                                    },
                                    lang['store.password_change.change_password']
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);
    return PasswordChangeView;
}(_react2.Component), _class.propTypes = {
    disabledSubmit: _react2.PropTypes.bool.isRequired,
    error: _react2.PropTypes.string,
    newPass: _react2.PropTypes.string.isRequired,
    newRePass: _react2.PropTypes.string.isRequired,
    oldPass: _react2.PropTypes.string.isRequired,
    onSubmit: _react2.PropTypes.func.isRequired,
    lang: _react2.PropTypes.object
}, _temp2));

exports.default = PasswordChangeView;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PasswordChange/default/PasswordChangeView.jsx
// module id = 1732
// module chunks = 0